import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { get as getUser } from 'js/lib/user';

import type {
  GetLearnerVerificationRequirements,
  GetLearnerVerificationRequirementsVariables,
} from 'bundles/accomplishments/queries/hooks/__generated__/GetLearnerVerificationRequirements';

export const GET_LEARNER_VERIFICATION_REQUIREMENTS_QUERY = gql`
  query GetLearnerVerificationRequirements($ids: [String!]!) {
    UserVerificationRequirementsV1Resource {
      multiGet(ids: $ids) {
        elements {
          id
          userVerificationRequirementState
        }
      }
    }
  }
`;
export const useLearnerVerificationRequirements = (userId = getUser().id.toString()) => {
  const { data, loading, error } = useQuery<
    GetLearnerVerificationRequirements,
    GetLearnerVerificationRequirementsVariables
    // Note: this endpoint will only return data if the userId is that of the current user (unless you are a superuser).
    // Otherwise, verificationRequirements will be undefined.
  >(GET_LEARNER_VERIFICATION_REQUIREMENTS_QUERY, {
    variables: {
      ids: [userId],
    },
    skip: !userId,
  });

  const verificationRequirements =
    data?.UserVerificationRequirementsV1Resource?.multiGet?.elements?.[0]?.userVerificationRequirementState;

  return {
    verificationRequirements,
    loading,
    error,
  };
};
